;(function() {
/* @ngInject */
function DomainController(IndexService, $timeout, $scope, $filter) {
    let vm = this;

    let service = IndexService;

    vm.loaded = false;

    $scope.$watch('vm.domain.name', function () {
        getDomain();
    }, true);

    vm.setDomain = setDomain;

    function getDomain() {
        vm.loaded = false;
        if(vm.domain.name && vm.domain.name.length > 0) {
            let domain = angular.copy(vm.domain.name);
            let dotIndex = domain.lastIndexOf(".");

            if (dotIndex > 0) {
                let namePart = domain.slice(0, dotIndex);
                let tld = domain.slice(dotIndex);

                let cleaned = $filter("lowercase")(
                    $filter("whitespaceFilter")(
                        namePart
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f,\.]/g, "")
                    )
                );

                vm.domain.name = cleaned + tld;
                service.getDomainInfo(vm.domain.name).then((ms) => {
                    vm.domain.isFree = ms;
                    vm.loaded = true;
                });
            }
        }
    }

    function setDomain() {
        vm.domain.active = !vm.domain.active;
    }

    $timeout(function() {
        getDomain();
    });
}

angular.module("firmaren")
    .component("domain", {
        templateUrl: "/app/shared/domain/domain.html",
        controller: DomainController,
        controllerAs: "vm",
        bindings: {
            domain: "="
        }
    });
}());
